import React from 'react';
import { Link } from 'react-router-dom';

const InterPageLinkUp = ({ link }) => {
  let text;

  switch (link) {
    case 'calculate-aggregate-score':
      text = 'Calculate your aggregate score';
      break;
    case 'admission-probability':
      text = 'Check your probability of gaining admission';
      break;
    // no default
  }

  return (
    <div className="sub-text txt-al-c">
      <p className="m-t-20">{`${text}`} <Link to={`/${link}`} className="text-link">here</Link>.</p>
      <p className="m-t-10">Check out other awesome stuff 🤘 that you can do on Versitails <Link to='/' className="text-link">here</Link>.</p>
    </div>
  );
};

export default InterPageLinkUp;
